
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.3477 15.9986L25.5075 8.85447C25.821 8.54089 25.9972 8.11558 25.9972 7.67211C25.9972 7.22864 25.821 6.80333 25.5075 6.48975C25.1939 6.17617 24.7687 6 24.3253 6C23.8819 6 23.4566 6.17617 23.1431 6.48975L16 13.6505L8.8569 6.48975C8.54337 6.17617 8.11812 6 7.67471 6C7.2313 6 6.80606 6.17617 6.49252 6.48975C6.17898 6.80333 6.00284 7.22864 6.00284 7.67211C6.00284 8.11558 6.17898 8.54089 6.49252 8.85447L13.6523 15.9986L6.49252 23.1427C6.33646 23.2975 6.21259 23.4817 6.12805 23.6846C6.04352 23.8875 6 24.1052 6 24.3251C6 24.5449 6.04352 24.7626 6.12805 24.9655C6.21259 25.1684 6.33646 25.3526 6.49252 25.5074C6.64731 25.6635 6.83147 25.7874 7.03437 25.8719C7.23727 25.9565 7.4549 26 7.67471 26C7.89452 26 8.11215 25.9565 8.31505 25.8719C8.51796 25.7874 8.70211 25.6635 8.8569 25.5074L16 18.3466L23.1431 25.5074C23.2979 25.6635 23.482 25.7874 23.6849 25.8719C23.8878 25.9565 24.1055 26 24.3253 26C24.5451 26 24.7627 25.9565 24.9656 25.8719C25.1685 25.7874 25.3527 25.6635 25.5075 25.5074C25.6635 25.3526 25.7874 25.1684 25.8719 24.9655C25.9565 24.7626 26 24.5449 26 24.3251C26 24.1052 25.9565 23.8875 25.8719 23.6846C25.7874 23.4817 25.6635 23.2975 25.5075 23.1427L18.3477 15.9986Z","fill":"#FD5105"}})])
          )
        }
      }
    